// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__114bi","bigColWidth":"Table_bigColWidth__1k0IL","biggerColWidth":"Table_biggerColWidth__39h_x","row":"Table_row__2HgJp","col":"Table_col__3LgMQ"};